<ion-header mode="md" no-border>
    <ion-toolbar mode="md" color="lightblue">
        <ion-title> {{ 'newGoalModal.newGoal' | translate }}</ion-title>
        <ion-buttons slot="end">
            <ion-button
                    mode="ios"
                    size="small"
                    color="light"
                    (click)="dismiss(false)"
            >
                <ion-icon class="bp-close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
    <ion-list
            mode="ios"
            lines="none"
            class="new-goals-form"
            [formGroup]="formGroup"
    >
        <ion-item *ngIf="processConfig.title">
            <ion-label position="stacked" color="primary">
                {{ getText(processConfig.title.globalizationConfig, 'title') }}
                <ion-button
                        color="lightblue"
                        shape="round"
                        mode="ios"
                        [matTooltip]="getText( processConfig.title.globalizationConfig, 'instructions' )"
                >?
                </ion-button
                >
            </ion-label>
            <ion-input
                    formControlName="title"
            ></ion-input>
        </ion-item>
        <ion-item *ngIf="processConfig.description">
            <ion-label position="stacked" color="primary">
                {{ getText(processConfig.description.globalizationConfig, 'title') }}
                <ion-button
                        color="lightblue"
                        shape="round"
                        mode="ios"
                        [matTooltip]="getText( processConfig.description.globalizationConfig, 'instructions' )"
                >?
                </ion-button
                >
            </ion-label>
            <ion-textarea
                    [placeholder]="getText( processConfig.description.globalizationConfig, 'placeholder' )"
                    formControlName="description"
                    [maxlength]="processConfig.description.typeConfig.max"
            ></ion-textarea>
        </ion-item>
        <ion-item *ngIf="processConfig.deadline">
            <ion-label position="stacked" color="primary">
                {{ getText(processConfig.deadline.globalizationConfig, 'title') }}
                <ion-button
                        color="lightblue"
                        shape="round"
                        mode="ios"
                        [matTooltip]="getText( processConfig.deadline.globalizationConfig, 'instructions' )"
                >?
                </ion-button
                >
            </ion-label>
            <mat-form-field>
                <input matInput [ngxMatDatetimePicker]="pickerDeadline" formControlName="deadline"
                        readonly>
                <mat-datepicker-toggle matSuffix [for]="pickerDeadline"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #pickerDeadline [showSpinners]="false" [showSeconds]="true"
                                            [stepSecond]="10" [touchUi]="false" [enableMeridian]="false"
                                            [disableMinute]="false">
                </ngx-mat-datetime-picker>
            </mat-form-field>
        </ion-item>
        <ion-item *ngIf="processConfig.weight">
            <ion-label position="stacked" color="primary">
                {{ getText(processConfig.weight.globalizationConfig, 'title') }}
                <ion-button
                        color="lightblue"
                        shape="round"
                        mode="ios"
                        [matTooltip]="getText( processConfig.weight.globalizationConfig, 'instructions' )"
                >?
                </ion-button
                >
            </ion-label>
            <ion-input
                    type="number"
                    min="1"
                    max="100"
                    [placeholder]="getText( processConfig.weight.globalizationConfig, 'placeholder' )"
                    (ionBlur)="checkWeight($event.target.value)"
                    formControlName="weight"
            ></ion-input>
        </ion-item>
        <ng-container
                *ngFor="let question of processConfig.questions; let qIndex = index"
        >
            <ion-item>
                <ion-label position="stacked" color="primary">
                    {{ getText(question.globalizationConfig, 'title') }}
                    <ion-button
                            color="lightblue"
                            shape="round"
                            mode="ios"
                            [matTooltip]="getText( question.globalizationConfig, 'instructions' )"
                    >?
                    </ion-button
                    >
                </ion-label>
                <ng-container [ngSwitch]="question.typeConfig.type">
                    <ng-container
                            *ngIf="question?.typeConfig && question?.typeConfig?.max < 100"
                    >
                        <ion-input
                                *ngSwitchCase="QuestionType.Text"
                                [placeholder]="getText( question.globalizationConfig, 'placeholder' )"
                                [formControlName]="'field' + (qIndex + 1)"
                        ></ion-input>
                        <ion-input
                                *ngSwitchCase="QuestionType.Title"
                                [placeholder]="getText( question.globalizationConfig, 'placeholder' )"
                                [formControlName]="'field' + (qIndex + 1)"
                        ></ion-input>
                    </ng-container>

                    <ng-container
                            *ngIf="question?.typeConfig && question?.typeConfig?.max >= 100"
                    >
                        <ion-textarea
                                *ngSwitchCase="QuestionType.Text"
                                [placeholder]="getText( question.globalizationConfig, 'placeholder' )"
                                [formControlName]="'field' + (qIndex + 1)"
                                [maxlength]="question.typeConfig.max"
                        ></ion-textarea>
                        <ion-textarea
                                *ngSwitchCase="QuestionType.Description"
                                [placeholder]="getText( question.globalizationConfig, 'placeholder' )"
                                [formControlName]="'field' + (qIndex + 1)"
                                [maxlength]="question.typeConfig.max"
                        ></ion-textarea>
                    </ng-container>
                    <mat-form-field *ngSwitchCase="QuestionType.Date">
                        <input matInput [matDatepicker]="pickerDateType" [formControlName]="'field' + (qIndex + 1)" disabled>
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="pickerDateType"></mat-datepicker-toggle>
                        <mat-datepicker #pickerDateType></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field *ngSwitchCase="QuestionType.Deadline">
                        <input matInput [matDatepicker]="pickerDeadlineType" [formControlName]="'field' + (qIndex + 1)" disabled>
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="pickerDeadlineType"></mat-datepicker-toggle>
                        <mat-datepicker #pickerDeadlineType></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field *ngSwitchCase="QuestionType.InitialDeadline">
                        <input matInput [matDatepicker]="pickerInitialDeadlineType" [formControlName]="'field' + (qIndex + 1)" disabled>
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="pickerInitialDeadlineType"></mat-datepicker-toggle>
                        <mat-datepicker #pickerInitialDeadlineType></mat-datepicker>
                    </mat-form-field>

                    <ion-input
                            *ngSwitchCase="QuestionType.Number"
                            type="number"
                            [placeholder]="getText( question.globalizationConfig, 'placeholder' )"
                            [formControlName]="'field' + (qIndex + 1)"
                            (ionBlur)="checkWeight($event.target.value)"
                    ></ion-input>

                    <ion-input
                            *ngSwitchCase="QuestionType.Weight"
                            type="number"
                            min="1"
                            max="100"
                            [placeholder]="getText( question.globalizationConfig, 'placeholder' )"
                            [formControlName]="'field' + (qIndex + 1)"
                            (ionBlur)="checkWeight($event.target.value)"
                    ></ion-input>

                    <ion-select
                            *ngSwitchCase="QuestionType.Selection"
                            [placeholder]="getText(question.globalizationConfig, 'placeholder')"
                            [formControlName]="'field' + (qIndex + 1)"
                    >
                        <ng-container *ngFor="let opValue of question.typeConfig.possibleValues; let index = index">
                            <ion-select-option *ngIf="isOptionVisible(question.typeConfig, index)" [value]="opValue">
                                {{ getTypeValues(question.typeConfig, index) }}
                            </ion-select-option>
                        </ng-container>
                    </ion-select>
                </ng-container>
            </ion-item>
        </ng-container>
    </ion-list>
</ion-content>
<ion-footer mode="ios">
    <ion-toolbar mode="ios">
        <ion-row>
            <ion-col size="6">
                <ion-button
                        color="danger"
                        expand="block"
                        mode="ios"
                        (click)="dismiss(false)"
                >
                    {{ 'generic.cancel' | translate }}
                </ion-button>
            </ion-col>
            <ion-col size="6">
                <ion-button
                        color="primary"
                        expand="block"
                        mode="ios"
                        (click)="save(formGroup)"
                >
                    {{ 'generic.save' | translate }}
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-toolbar>
</ion-footer>
